import { render, staticRenderFns } from "./company-field.vue?vue&type=template&id=35e2040f"
import script from "./company-field.vue?vue&type=script&lang=js"
export * from "./company-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports